import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgCalendar({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 2a1 1 0 011 1v1h1a3 3 0 013 3v12a3 3 0 01-3 3H5a3 3 0 01-3-3V7a3 3 0 013-3h1V3a1 1 0 012 0v1h8V3a1 1 0 011-1zm3 8H4v9a1 1 0 001 1h14a1 1 0 001-1v-9zm-9 6a1 1 0 110 2H7a1 1 0 110-2h4zm6-4a1 1 0 110 2H7a1 1 0 110-2h10zm2-6H5a1 1 0 00-1 1v1h16V7a1 1 0 00-1-1z"
        fill={color}
      />
    </svg>
  )
}

export default SvgCalendar
